import './index.scss';

class HeaderSearch {
    constructor(root) {
        this.root = root;
        this.overlayContainer = null;
        this.searchInput = null;
        this.searchResultsContainer = null;
        this.searchSubmitButton = null;
        this.debounceTimer = null;
        this.lastQuery = '';

        this.root.addEventListener('click', (event) => {
            event.preventDefault();

            if (this.overlayContainer === null) {
                this.openSearch();
            } else {
                window.app.siteHeader.closeOverlay();
            }
        });

        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        if (this.overlayContainer !== null) {
            window.app.siteHeader.closeOverlay();
        }
    }

    openSearch() {
        this.overlayContainer = window.app.siteHeader.openOverlay(this.closeSearch.bind(this), false);
        this.overlayContainer.innerHTML = this.getSearchHtml();

        this.searchInput = this.overlayContainer.querySelector('.tx-indexedsearch-searchbox-sword');
        this.searchResultsContainer = this.overlayContainer.querySelector('.search-results');
        this.searchSubmitButton = this.overlayContainer.querySelector('.tx-indexedsearch-search-submit');

        if (this.searchSubmitButton) {
            this.searchSubmitButton.style.display = 'none';
        }

        this.searchInput.addEventListener('input', () => this.debounce(this.performSearch.bind(this), 300));
    }

    closeSearch() {
        if (this.overlayContainer !== null) {
            this.overlayContainer = null;
        }
    }

    getSearchHtml() {
        let searchHtml = document.querySelector('.header-search').innerHTML;
        return searchHtml;
    }

    debounce(callback, delay) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(callback, delay);
    }

    performSearch() {
        const query = this.searchInput.value.trim();

        if (!query) {
            this.clearSearchResults();
            return;
        }

        if (query.length < 3) {
            return;
        }

        if (query === this.lastQuery) {
            return;
        }
        this.lastQuery = query;

        const searchUrl = this.searchResultsContainer.dataset.searchurl;

        const postData = new URLSearchParams();
        postData.append('tx_westfleisch_pi2[sword]', query);

        fetch(`${searchUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: postData.toString()
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then((html) => {
                this.updateSearchResults(html);
            })
            .catch((error) => {
                console.error('Error fetching search results:', error);
            });
    }

    updateSearchResults(html) {
        this.searchResultsContainer.innerHTML = html;

        if (html.trim() !== '') {
            this.searchSubmitButton.style.display = '';
        } else {
            this.searchSubmitButton.style.display = 'none';
        }
    }

    clearSearchResults() {
        this.searchResultsContainer.innerHTML = '';

        if (this.searchSubmitButton) {
            this.searchSubmitButton.style.display = 'none';
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('[data-funct="toggle-search"]').forEach((node) => {
        new HeaderSearch(node);
    });
});

window.app.run(() => {
    document.querySelectorAll('.toggle--search').forEach((node) => {
        new HeaderSearch(node);
    });
});
